<template>
  <div>
    <form
      action="/bohee/bop/api/system/syspoi/fileexport"
      ref="exportFrom"
      method="POST"
      style="display:none"
      target="_self"
    >
      <input ref="exportInput" name="poiEntity" />
    </form>
    <el-button @click="sendFileExport" :disabled="disabled">{{name}}</el-button>
  </div>
</template>
<script>
export default {
  name: "fileExport",
  props: {
    data: {
      type: Array,
      required: true
    },
    header: {
      type: Object,
      required: true
    },
    name: {
      type: String,
      default: "导出"
    },
    disabled: {
      type: Boolean,
      default: false
    },
    fileName: {
      type: String,
      required: true
    }
  },
  methods: {
    sendFileExport() {
      if (!this.disabled) {
        if (this.fileName) 
        {
          this.$set(this.header, "data", this.data);
          this.$set(
            this.header,
            "tableName",
            this.fileName + "费用成本科目模板"
          );
          // this.$refs.exportInput.value = JSON.stringify(this.header);
          // this.$refs.exportFrom.submit();
          
          this.$http
            .post(this.api.poiExeclExport, this.header, {
              responseType: "blob"
            })
            .then(res => {
              //此处有个坑。这里用content保存文件流，最初是content=res，但下载的test.xls里的内容如下图1，
              //检查了下才发现，后端对文件流做了一层封装，所以将content指向res.data即可
              //另外，流的转储属于浅拷贝，所以此处的content转储仅仅是便于理解，并没有实际作用=_=
              const content = res.data;
              const blob = new Blob([content]); //构造一个blob对象来处理数据
              const fileName = this.fileName + "费用成本科目模板.xlsx";

              //对于<a>标签，只有 Firefox 和 Chrome（内核） 支持 download 属性
              //IE10以上支持blob但是依然不支持download
              if ("download" in document.createElement("a")) {
                //支持a标签download的浏览器
                const link = document.createElement("a"); //创建a标签
                link.download = fileName; //a标签添加属性
                link.style.display = "none";
                link.href = URL.createObjectURL(blob);
                document.body.appendChild(link);
                link.click(); //执行下载
                URL.revokeObjectURL(link.href); //释放url
                document.body.removeChild(link); //释放标签
              } else {
                //其他浏览器
                navigator.msSaveBlob(blob, fileName);
              }
            });
        } else {
          this.$message.error("请输入模板名称后再导出！");
        }
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/export/fileExport.vue